import { Descriptions } from "antd";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import React from "react";
import { TicketTypedMetaField } from "../../../types/TicketMeta";

type Props = {
  meta: TicketTypedMetaField & { type: "date" };
};

export const MetaDate = observer((props: Props) => {
  let displayValue = dayjs(props.meta.value)?.format("DD.MM.YYYY HH:mm:ss");

  return (
    <Descriptions.Item label={props.meta.label} key={props.meta.label}>
      {displayValue}
    </Descriptions.Item>
  );
});
